import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import { Provider } from "mobx-react";
import App from "./router/index";
import AppStore from "./mobx/index";
import { BrowserRouter as Router } from "react-router-dom";

import "./styles/index.css";
import "./styles/index.scss";
import { getAppStyle } from "./utils/condition";

// console.log(`__APISUFFIX__`, __APISUFFIX__)
if (__APISUFFIX__ === "-dev" || __APISUFFIX__ === "-test") {
  const Vconsole = require("vconsole");
  new Vconsole();
}

// 获取环境类型
AppStore.setCondition(getAppStyle());
console.log("我进判断", location.host);

// if (location.host.includes("thepaper.cn")) {
//   const originalUrl = location.host;
//   const pattern = /https:\/\/(html)(?:-(\w+))?\.thepaper\.cn/;
//   debugger;
//   const env = originalUrl.match(pattern)[2] || "";
//   if (__APISUFFIX__ == "-pre" || __APISUFFIX__ == "") {
//     window.location.href = originalUrl.replace(
//       pattern,
//       `https://${env ? "m-" + env : "m"}.pai-tech.net` +
//         location.pathname +
//         "?tenantId=10002876"
//     );
//   } else {
//     window.location.href = originalUrl.replace(
//       pattern,
//       `https://${env ? "m-" + env : "m"}.pai-tech.net` +
//         location.pathname +
//         "?tenantId=10001194"
//     );
//   }
// }

if (location.host.includes("thepaper.cn")) {
  // const pattern = /^https:\/\/(html)(?:-(\w+))?\.thepaper\.cn$/;
  const pattern = /^(html)(?:-(\w+))?\.thepaper\.cn$/; 
  const newPath = "https://html-test.thepaper.cn";
  const matches = location.host.match(pattern);
  console.log("matches", matches);
  if (matches) {
    const env = matches[2] || "";
    const isPreOrProd = __APISUFFIX__ === "-pre" || __APISUFFIX__ === "";
    const tenantId = isPreOrProd ? "10002876" : "10001194";

    const newHost = `${env ? "m-" + env : "m"}.pai-tech.net`;
    const newUrl = `https://${newHost}${location.pathname}?tenantId=${tenantId}`;

    window.location.href = newUrl;
  }
}

if (__DEV__) {
  ReactDOM.render(
    <Router>
      <Provider appStore={AppStore}>
        <App />
      </Provider>
    </Router>,
    document.getElementById("app")
  );
} else {
  ReactDOM.render(
    <Router>
      <Provider appStore={AppStore}>
        <App />
      </Provider>
    </Router>,
    document.getElementById("app")
  );
}
